'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _boardConstants = require('./boardConstants');

var _elementRegistry = require('../elements/elementRegistry');

var _elementConstructor = require('../elements/elementConstructor');

var _elementConstructor2 = _interopRequireDefault(_elementConstructor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var objectConstructorFn = function objectConstructorFn(params) {
    var content = params.content,
        acl = params.acl;

    return _extends({}, (0, _elementConstructor2.default)(params), {
        elementType: _boardConstants.BOARD_TYPE,
        content: _extends({
            title: _boardConstants.BOARD_DEFAULT_TITLE,
            icon: null,
            color: null
        }, content),
        acl: acl
    });
};

exports.default = function () {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, _elementRegistry.registerElementType)(_extends({
        elementType: _boardConstants.BOARD_TYPE,
        objectConstructorFn: objectConstructorFn,
        displayName: _boardConstants.BOARD_DISPLAY_NAME
    }, params));
};


//////////////////
// WEBPACK FOOTER
// ./src/common/boards/index.js
// module id = 2253
// module chunks = 0